import * as z from "zod";
import { TFunction } from "i18next";

export const createFranchiseFormSchema = (t: TFunction) =>
  z.object({
    name: z.string().min(1, t("validation.required", "This field is required")),
    surname: z
      .string()
      .min(1, t("validation.required", "This field is required")),
    email: z.string().email(t("validation.emailInvalid", "Invalid email")),
    phone: z
      .string()
      .min(10, t("validation.phoneInvalid", "Invalid phone number")),
    city: z.string().min(1, t("validation.required", "City is required")),
    district: z
      .string()
      .min(1, t("validation.required", "District is required")),
    message: z.string().optional(),
    nickname: z.string().optional(),
    formLoadTimestamp: z.number().optional(),
  });

export type FranchiseFormData = z.infer<
  ReturnType<typeof createFranchiseFormSchema>
>;
